var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createContext, useContext, useState, useRef, useCallback, useMemo, useEffect } from 'react';
import { v4 as uid } from 'uuid';
import { Portal } from 'modules/v2/foundation/PortalProvider/Portal';
import { Toast } from './Toast';
import { Container } from './styled';
const Context = createContext({
    addToast: () => { },
});
export const useToast = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
};
export function ToastProvider(props) {
    const { children } = props;
    const [toasts, setToasts] = useState([]);
    const toastTimeoutsRef = useRef([]);
    const removeToast = useCallback((id) => {
        setToasts((currentToasts) => currentToasts.map((toast) => {
            if (toast.id === id) {
                return Object.assign(Object.assign({}, toast), { visible: false });
            }
            return toast;
        }));
    }, []);
    useEffect(() => {
        const toastTimeoutsRefCurrent = toastTimeoutsRef.current;
        return () => {
            toastTimeoutsRefCurrent.forEach((timeout) => clearTimeout(timeout));
        };
    }, []);
    const addToast = useCallback((value) => {
        const id = uid();
        const toast = Object.assign({ id }, value);
        const { timeout = 6000, action } = value;
        const newToast = Object.assign(Object.assign({}, toast), { timeout,
            action, visible: true });
        setToasts((currentToasts) => {
            const visible = currentToasts.filter((t) => t.visible);
            return [...visible, newToast];
        });
        if (!action) {
            const toastTimeout = window.setTimeout(() => {
                removeToast(id);
            }, timeout);
            toastTimeoutsRef.current.push(toastTimeout);
        }
    }, [removeToast]);
    const context = useMemo(() => ({ addToast }), [addToast]);
    return (<Context.Provider value={context}>
      {children}
      <Portal isToast>
        <Container flexDirection="column" gap="sm">
          {toasts.map((_a) => {
            var { id } = _a, toast = __rest(_a, ["id"]);
            return (<Toast key={id} onClose={() => removeToast(id)} {...toast}/>);
        })}
        </Container>
      </Portal>
    </Context.Provider>);
}
